"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

const Table = dynamic(async () =>
  withValidation(tableInputs, (await import("./Table")).Table, "Table")
);

export const tableInputs = [
  {
    name: "text",
    type: "tableEditor",
    defaultValue: `<p class="editor-paragraph"><br /></p>`,
  },
] as const satisfies Inputs;

export const TableComponent: RegisteredComponent = {
  name: "Table",
  component: Table,
  inputs: tableInputs,
  image:
    "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgd2lkdGg9IjgwMHB4IiBoZWlnaHQ9IjgwMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNMyA5TDIxIDlNMTIgOVYyME02LjIgMjBIMTcuOEMxOC45MjAxIDIwIDE5LjQ4MDIgMjAgMTkuOTA4IDE5Ljc4MkMyMC4yODQzIDE5LjU5MDMgMjAuNTkwMyAxOS4yODQzIDIwLjc4MiAxOC45MDhDMjEgMTguNDgwMiAyMSAxNy45MjAxIDIxIDE2LjhWNy4yQzIxIDYuMDc5OSAyMSA1LjUxOTg0IDIwLjc4MiA1LjA5MjAyQzIwLjU5MDMgNC43MTU2OSAyMC4yODQzIDQuNDA5NzMgMTkuOTA4IDQuMjE3OTlDMTkuNDgwMiA0IDE4LjkyMDEgNCAxNy44IDRINi4yQzUuMDc5OSA0IDQuNTE5ODQgNCA0LjA5MjAyIDQuMjE3OTlDMy43MTU2OSA0LjQwOTczIDMuNDA5NzMgNC43MTU2OSAzLjIxNzk5IDUuMDkyMDJDMyA1LjUxOTg0IDMgNi4wNzk4OSAzIDcuMlYxNi44QzMgMTcuOTIwMSAzIDE4LjQ4MDIgMy4yMTc5OSAxOC45MDhDMy40MDk3MyAxOS4yODQzIDMuNzE1NjkgMTkuNTkwMyA0LjA5MjAyIDE5Ljc4MkM0LjUxOTg0IDIwIDUuMDc5ODkgMjAgNi4yIDIwWiIgc3Ryb2tlPSIjMDAwMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9zdmc+",
};
